<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("zoom_meeting.zoom_manager") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="goToAddPage"
    >
      {{ this.$t("common.add_new") }}
    </md-button>
  </div>
</template>

<script>
import { ZoomMeeting } from "@/constants/Permissions";
import { zoom_meeting_names } from "@/routes/routes";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";

export default {
  name: "ListPageHeader",
  data() {
    return {
      name: "addTerm"
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    canAdd() {
      return (
        this.$can(ZoomMeeting.actions.add, ZoomMeeting.subject) &&
        !hasValidRole(this.userRole, Role.Teacher)
      );
    }
  },
  methods: {
    goToAddPage() {
      this.$router.push({ name: zoom_meeting_names.addPage });
    }
  }
};
</script>
